import React, { useState } from "react";
import {
	Card,
	CardContent,
	Divider,
	Grid,
	Container,
	Typography,
	makeStyles,
	Button,
	DialogContent,
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

import data from "data/about.json";
import { useAuth } from "contexts/auth-context";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
	container: { padding: theme.spacing(4, 3, 4, 3) },

	image: {
		height: 200,
		 width: 175,
		borderRadius: theme.shape.borderRadius,
		boxShadow: theme.shadows[1],
	},
	divider: {
		margin: theme.spacing(2),
	},
}));
const Person = (props) => {
	const { image, title, organization, links, name, bio } = props;
	const [showBio, setShowBio] = useState(false);
	const classes = useStyles();
	return (
		<div>
			{image && (
				<img
					className={classes.image}
					src={`${process.env.PUBLIC_URL}/${image}`}
				/>
			)}
			<Typography variant="h5">{name}</Typography>
			<Typography>{title}</Typography>
			<Typography>{organization}</Typography>
			{bio && (
				<Button
					variant="outlined"
					size="small"
					onClick={() => setShowBio(true)}
				>
					Read {name}'s Bio
				</Button>
			)}
			<ul>
				{links.map(({ title, href }, i) => (
					<li key={i}>
						<a href={href}>{title}</a>
					</li>
				))}
			</ul>
			<Dialog onClose={() => setShowBio(false)} open={showBio}>
				<DialogTitle id="simple-dialog-title">{name}'s Bio</DialogTitle>
				<DialogContent>
					<Typography gutterBottom>{bio}</Typography>
				</DialogContent>
			</Dialog>
		</div>
	);
};
function About() {
	const classes = useStyles();
	const { user } = useAuth();

	return (
		<Container className={classes.container}>
			<Grid container direction="row" spacing={2}>
				<Grid item xs={12} md={6}>
					<Typography variant="h4" component="h1" gutterBottom>
						About
					</Typography>
					<Typography gutterBottom>{data?.intro}</Typography>
					<Button
						fullWidth
						style={{ marginTop: 8 }}
						variant="outlined"
						color="primary"
						component={Link}
						to="/about/alumni"
					>
						See all the Research Group Alumni
					</Button>
					<br></br>
					<Button
						fullWidth
						style={{ marginTop: 8 }}
						variant="outlined"
						color="primary"
						component={Link}
						to="Publications"
					>
						See all the Research Group Publications
					</Button>
				</Grid>
				<Grid
					item
					xs={12}
					md={6}
					style={{ display: "flex", justifyContent: "center" }}
				>
					<div>
						<Typography variant="h4" component="h1">
							Director
						</Typography>
						<Person {...data?.director} />
					</div>
				</Grid>
			</Grid>
			<Divider className={classes.divider} />
			<Typography variant="h4" component="h1" gutterBottom>
				City@UMD Members
			</Typography>
			<br />
			<Grid container direction="row" spacing={2}>
				{data?.members.map((member, i) => (
					<Grid key={`person:${i}`} sm={12} md={4} xl={3}>
						<Person {...member} />
					</Grid>
				))}
			</Grid>
		</Container>
	);
}
export default About;
